module.exports = __webpack_public_path__ + "static/media/205.82594560.jpg";